import type { TypedUseSelectorHook } from 'react-redux'
import { useDispatch as useRRDispatch, useSelector as useRRSelector } from 'react-redux'
import type { AppDispatch } from './index.ts'
import type { State } from './Slice/index.ts'

/*
 * The typed hooks, apart from the store module: a component a slice reaches at runtime (the visualisation
 * sinks via VisualizationSlice) must not import the store, or evaluating the slices first (Vite hot
 * updates do) runs the store before its slices exist.
 */
export const useDispatch: () => AppDispatch = useRRDispatch
export const useSelector: TypedUseSelectorHook<typeof State> = useRRSelector
